import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './AdminTitleBar.styles';

import AddButton from '../../../components/inputs/addbutton/AddButton';

const AdminTitleBar = props => {
  const {
    styles: customStyles,
    handleAdd,
    addButtonRemove,
    ...rest
  } = props;
  return (
    <div className={css(styles.base, customStyles)} {...rest}>
      {props.title}
      {addButtonRemove === undefined && <AddButton onClick={handleAdd} />}
    </div>
  );
};

export default AdminTitleBar;



// WEBPACK FOOTER //
// ./src/components/common/admintitlebar/AdminTitleBar.js